import { Collection, Flex, Image, Text, View } from "@aws-amplify/ui-react";
import { Grid } from "@mui/material";
import { images } from "constants/index";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export const UpcomingEvents = () => {
  const imageList = [{ page: images.img7 }, { page: images.img6 }];

  const imageList2 = [{ page: images.img4 }, { page: images.img3 }];

  const navigate = useNavigate();

  const handleDonationClicked = () => {
    window.open("https://donate.stripe.com/14kdSG6OF7Crcb65kk");
  };

  return (
    <Flex
      width="100%"
      height="auto"
      //  backgroundColor='#BCD4BD'
      position="relative"
      direction="column"
      id="upcoming-events"
      overflow="scroll"
      // justifyContent="flex-start"
      paddingTop="30px"
      // marginTop="60px"

      paddingLeft="10px"
      paddingRight="10px"
    >
      <Text
        position="relative"
        fontSize="40px"
        color="white"
        // backgroundColor="red"
        // paddingTop="15px"
        paddingLeft="10px"
      >
        <div className=" font-lolita-one">Previous Events...</div>
      </Text>

      <Grid
        container
        position="relative"
        display="flex"
        direction="row"
        wrap="nowrap"
        width="auto"
        gap="20px"
        // backgroundColor="brown"

        height="auto"
        // justifyContent={matches ? "center" : "flex-start"}
        justifyContent="flex-start"
        paddingTop="25px"
        paddingLeft="20px"
        paddingRight="20px"
        alignContent="center"
        paddingBottom="25px"
        sx={{
          overflowY: "scroll",
        }}

        // alignContent="center"
        // backgroundColor="red"
      >
        <motion.div
          initial={{
            opacity: 0.6,
            scale: 0.8,
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
          }}
          transition={{
            duration: 2,
            type: "spring",
          }}
        >
          <Grid
            container
            position="relative"
            display="flex"
            direction="column"
            borderRadius="15px"
            // className="bg-[rgba(255,255,255,.9)]"
            bgcolor="rgba(255,255,255,.9)"
            wrap="nowrap"
            // zIndex="9999px"
            // className=' flex-col '

            width="300px"
            height="550px"
            // backgroundColor="yellow"
          >
            <View className=" relative justify-center items-center ">
              <Image
                alt=""
                src={images.img8}
                height="430px"
                objectFit="fill"
                borderRadius="15px"
              />
            </View>

            <View
              position="relative"
              // justifyContent="flex-start"
              // alignItems="flex-start"
              //   direction="column"
              paddingLeft="5px"
              paddingRight="5px"

              // paddingTop="10px"
            >
              <Text
                width="100%"
                textAlign="center"
                fontSize="20px"
                fontWeight="bold"
              >
                10000 Pounds Food Drop!
              </Text>

              <View
                paddingBottom="0px"
                className="relative flex  justify-center  items-center cursor-pointer pt-2"
              >
                <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <Text
                    display="flex"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    width="160px"
                    height="60px"
                    backgroundColor="rgba(32, 78, 41, 0.8)"
                    borderRadius="5px"
                    textAlign="center"
                    fontWeight="bold"
                    color="white"
                    className="focus:border-green active:border-green "
                    //  marginBottom="100px"

                    onClick={() => {
                      navigate("/VolunteerSignUp");
                    }}
                  >
                    Volunteer
                  </Text>
                </motion.button>
              </View>
            </View>
          </Grid>
        </motion.div>

        <motion.div
          initial={{
            opacity: 0.6,
            scale: 0.8,
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
          }}
          transition={{
            duration: 2,
            type: "spring",
          }}
        >
          <Grid
            container
            position="relative"
            display="flex"
            direction="column"
            borderRadius="15px"
            bgcolor="rgba(255,255,255,.9)"
            // backgroundColor="rgba(255,255,255,.9)"
            wrap="nowrap"
            // zIndex="9999px"
            // className=' flex-col '

            width="300px"
            height="550px"
            // backgroundColor="yellow"
          >
            <View className=" relative justify-center items-center ">
              <Image
                alt=""
                src={images.img1}
                height="430px"
                objectFit="fill"
                borderRadius="15px"
              />
            </View>

            <View
              position="relative"
              // justifyContent="flex-start"
              // alignItems="flex-start"
              //   direction="column"
              paddingLeft="5px"
              paddingRight="5px"

              // paddingTop="10px"
            >
              <Text
                width="100%"
                textAlign="center"
                fontSize="20px"
                fontWeight="bold"
              >
                Humbly seeking donations !
              </Text>

              <View
                paddingBottom="0px"
                className="relative flex  justify-center  items-center cursor-pointer pt-2"
              >
                <motion.button
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={handleDonationClicked}
                >
                  <Text
                    display="flex"
                    style={{
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    width="160px"
                    height="60px"
                    backgroundColor="rgba(32, 78, 41, 0.8)"
                    borderRadius="5px"
                    textAlign="center"
                    fontWeight="bold"
                    color="white"
                    className="focus:border-green active:border-green "
                    //  marginBottom="100px"

                    onClick={() => {
                      window.open("https://a.co/8t77kbO");
                    }}
                  >
                    Go To Amazon Wishlist
                  </Text>
                </motion.button>
              </View>
            </View>
          </Grid>
        </motion.div>

        <motion.div
          initial={{
            opacity: 0.6,
            scale: 0.8,
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
          }}
          transition={{
            duration: 2,
            type: "spring",
          }}
        >
          <Grid
            container
            position="relative"
            display="flex"
            direction="column"
            borderRadius="15px"
            bgcolor="rgba(255,255,255,.9)"
            wrap="nowrap"
            // zIndex="9999px"
            // className=' flex-col '

            width="300px"
            height="550px"
            // backgroundColor="yellow"
          >
            <View className=" relative flex-1 justify-center items-center ">
              <Collection
                items={imageList2}
                itemsPerPage={1}
                type="list"
                width="300px"
                height="auto"
                display="flex"
                isPaginated
                justifyContent="center"
                alignItems="center"
              >
                {(item, index) => (
                  <Image
                    alt=""
                    key={index}
                    src={item.page}
                    height="430px"
                    objectFit="fill"
                    borderRadius="15px"
                  />
                )}
              </Collection>
            </View>

            <Flex
              position="relative"
              justifyContent="center"
              alignItems="center"
              direction="column"
              paddingLeft="5px"
              paddingRight="5px"
              paddingTop="10px"
              paddingBottom="50px"
            >
              <Text
                width="100%"
                textAlign="center"
                fontSize="30px"
                fontWeight="bold"
              >
                DON'T MISS OUT!
              </Text>
            </Flex>
          </Grid>
        </motion.div>

        <motion.div
          initial={{
            opacity: 0.6,
            scale: 0.8,
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
          }}
          transition={{
            duration: 2,
            type: "spring",
          }}
        >
          <Grid
            container
            position="relative"
            display="flex"
            direction="column"
            borderRadius="15px"
            bgcolor="rgba(255,255,255,.9)"
            wrap="nowrap"
            width="300px"
            height="550px"
          >
            <View className=" relative flex-1 justify-center items-center ">
              <Collection
                items={imageList}
                itemsPerPage={1}
                type="list"
                width="300px"
                height="auto"
                display="flex"
                isPaginated
                justifyContent="center"
                alignItems="center"
              >
                {(item, index) => (
                  <Image
                    alt=""
                    key={index}
                    src={item?.page}
                    height="430px"
                    objectFit="fill"
                    borderRadius="15px"
                  />
                )}
              </Collection>
            </View>

            <Flex
              position="relative"
              justifyContent="center"
              alignItems="center"
              direction="column"
              paddingLeft="5px"
              paddingRight="5px"
              paddingTop="10px"
              paddingBottom="50px"
            >
              <Text
                width="100%"
                textAlign="center"
                fontSize="30px"
                fontWeight="bold"
              >
                DON'T MISS OUT!
              </Text>
            </Flex>
          </Grid>
        </motion.div>

        <motion.div
          initial={{
            opacity: 0.6,
            scale: 0.8,
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
          }}
          transition={{
            duration: 2,
            type: "spring",
          }}
        >
          <Grid
            container
            position="relative"
            display="flex"
            direction="column"
            borderRadius="15px"
            bgcolor="rgba(255,255,255,.9)"
            wrap="nowrap"
            width="300px"
            height="550px"
          >
            <Image
              alt=""
              borderRadius="15px"
              src={images.img2}
              height="480px"
              width="600px"
            />

            <Flex
              position="relative"
              justifyContent="center"
              alignItems="center"
              direction="column"
              paddingLeft="5px"
              paddingRight="5px"
              paddingTop="25px"
              paddingBottom="25px"
            >
              <Text width="100%" textAlign="center" fontSize="20px">
                Sign up your skater today!
              </Text>
              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={() => {
                  window.open(
                    "https://docs.google.com/forms/d/e/1FAIpQLSePbc24N3psTbMBRSbBRK0820IRNkop57MDtb04rP6xgNIaqA/viewform?usp=sf_link",
                  );
                }}
              >
                <Text
                  display="flex"
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  width="200px"
                  height="40px"
                  backgroundColor="rgba(32, 78, 41, 0.8)"
                  borderRadius="5px"
                  textAlign="center"
                  fontWeight="bold"
                  color="white"
                >
                  Sign Up
                </Text>
              </motion.button>
            </Flex>
          </Grid>
        </motion.div>

        <motion.div
          initial={{
            opacity: 0.6,
            scale: 0.8,
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
          }}
          transition={{
            duration: 2,
            type: "spring",
          }}
        >
          <Grid
            container
            position="relative"
            display="flex"
            direction="column"
            borderRadius="15px"
            bgcolor="rgba(255,255,255,.9)"
            wrap="nowrap"
            width="300px"
            height="550px"
          >
            <Image
              alt=""
              borderRadius="15px"
              src={images.img5}
              height="480px"
              width="600px"
            />

            <Flex
              position="relative"
              justifyContent="center"
              alignItems="center"
              direction="column"
              paddingLeft="5px"
              paddingRight="5px"
              paddingTop="25px"
              paddingBottom="25px"
            >
              <Text width="100%" textAlign="center" fontSize="20px">
                Sign up skater!
              </Text>

              <motion.button
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                onClick={() => {
                  navigate("/SkaterSignUp");
                }}
              >
                <Text
                  display="flex"
                  style={{
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                  width="200px"
                  height="40px"
                  backgroundColor="rgba(32, 78, 41, 0.8)"
                  borderRadius="5px"
                  textAlign="center"
                  fontWeight="bold"
                  color="white"
                >
                  Sign Up
                </Text>
              </motion.button>
            </Flex>
          </Grid>
        </motion.div>

        {/* <motion.div
              initial={{
                opacity: 0.6,
                scale: 0.8
             
              }}
                whileInView={{
                
                opacity: 1,
                scale: 1
        
              }}
              transition={{
                duration: 2,
                type:"spring"
               
              }} 
           
              
        
            
              >
            <Grid container
                
                position="relative"
                display="flex"
                direction="column"
                borderRadius="15px"
                backgroundColor="rgba(255,255,255,.9)"
                wrap="nowrap"
                // zIndex="9999px"
                // className=' flex-col '
                
        
                
                width="300px"
                height="550px"
                // backgroundColor="yellow"
                
                >
          <Image
          // src='/skteevent.JPG'
          borderRadius="15px"
          // src='/schoolDrive.jpg'
          src={img3}
          height="480px"
          width="600px"
          />
        
          <Flex
          position="relative"
          justifyContent="center"
          alignItems="center"
          direction="column"
          paddingLeft="5px"
          paddingRight="5px"
          paddingTop="25px"
          paddingBottom="25px">
        
        
          <Text 
          width="100%"
          textAlign="center"
          fontSize="20px"
          
          >
            Sign up to volunteer now!
          </Text>
           <motion.button
               
        
               whileHover={{ scale: 1.1 }}
               whileTap={{ scale: 0.9 }}
               onClick={() => {
                   navigate('/VolunteerSignUp')
               }}>
                   <Text
                   display="flex"
                   justifyContent="center"
                   alignItems="center"
                   width="200px"
                   height="40px"
                   backgroundColor="rgba(32, 78, 41, 0.8)"
                   borderRadius="5px"
                   textAlign="center"
                   fontWeight="bold"
                   color="white"
                   >
                   Sign Up
                   </Text>
          </motion.button>
          </Flex>
            </Grid>
           </motion.div>
        
            <motion.div
              initial={{
                opacity: 0.6,
                scale: 0.8
             
              }}
                whileInView={{
                
                opacity: 1,
                scale: 1
        
              }}
              transition={{
                duration: 2,
                type:"spring"
               
              }} 
           
              
        
            
              >
            <Grid container
                
                position="relative"
                display="flex"
                direction="column"
                borderRadius="15px"
                backgroundColor="rgba(255,255,255,.9)"
                wrap="nowrap"
                // zIndex="9999px"
                // className=' flex-col '
                
        
                
                width="300px"
                 height="550px"
                // backgroundColor="yellow"
                
                >
          <Image
          // src='/skteevent.JPG'
          borderRadius="15px"
          // src='/schoolDrive.jpg'
          src={img4}
          height="480px"
          width="600px"
          />
        
          <Flex
          position="relative"
          justifyContent="center"
          alignItems="center"
          direction="column"
          paddingLeft="5px"
          paddingRight="5px"
          paddingTop="25px"
          paddingBottom="25px">
        
        
          <Text 
          width="100%"
          textAlign="center"
          fontSize="20px"
          
          >
            Plug in!
          </Text>
        
        
           <motion.button
               
        
               whileHover={{ scale: 1.1 }}
               whileTap={{ scale: 0.9 }}
               onClick={() =>{
                window.open("https://docs.google.com/forms/d/e/1FAIpQLSeqXmdfnHQPSGH0r1DAZYvltkVL5gcj-Se5Ts9WFYXgdOzNlA/viewform?usp=sf_link")
                
              }}
               >
                   <Text
                   display="flex"
                   justifyContent="center"
                   alignItems="center"
                   width="200px"
                   height="40px"
                   backgroundColor="rgba(32, 78, 41, 0.8)"
                   borderRadius="5px"
                   textAlign="center"
                   fontWeight="bold"
                   color="white"
                   >
                   Sign Up
                   </Text>
          </motion.button>
        
          </Flex>
            </Grid>
           </motion.div>
        
          
        
           
        
           <motion.div
              initial={{
                opacity: 0.6,
                scale: 0.8
             
              }}
                whileInView={{
                
                opacity: 1,
                scale: 1
        
              }}
              transition={{
                duration: 2,
                type:"spring"
               
              }} 
           
              
        
            
              >
            <Grid container
                
                position="relative"
                display="flex"
                direction="column"
                borderRadius="15px"
                backgroundColor="rgba(255,255,255,.9)"
                wrap="nowrap"
                // zIndex="9999px"
                // className=' flex-col '
                
        
                
                width="300px"
                 height="550px"
                // backgroundColor="yellow"
                
                >
          <Image
          // src='/skteevent.JPG'
          borderRadius="15px"
          // src='/schoolDrive.jpg'
          src={img1}
          height="480px"
          width="600px"
          />
        
          <Flex
          position="relative"
          justifyContent="center"
          alignItems="center"
          direction="column"
          paddingLeft="5px"
          paddingRight="5px"
          paddingTop="25px"
          paddingBottom="25px">
        
        
          <Text 
          width="100%"
          textAlign="center"
          fontSize="20px"
          
          >
            Sign up skater!
          </Text>
        
        
           <motion.button
               
        
               whileHover={{ scale: 1.1 }}
               whileTap={{ scale: 0.9 }}
               onClick={() =>{
                navigate('/SkaterSignUp')
              }}
               >
                   <Text
                   display="flex"
                   justifyContent="center"
                   alignItems="center"
                   width="200px"
                   height="40px"
                   backgroundColor="rgba(32, 78, 41, 0.8)"
                   borderRadius="5px"
                   textAlign="center"
                   fontWeight="bold"
                   color="white"
                   >
                   Sign Up
                   </Text>
          </motion.button>
        
          </Flex>
            </Grid>
           </motion.div> */}

        {/* <motion.div
              initial={{
                opacity: 0.6,
                scale: 0.8
             
              }}
                whileInView={{
                
                opacity: 1,
                scale: 1
        
              }}
              transition={{
                duration: 2,
                type:"spring"
               
              }} 
           
              
        
            
              >
            <Grid container
                
                position="relative"
                display="flex"
                direction="column"
                borderRadius="15px"
                backgroundColor="rgba(255,255,255,.9)"
                wrap="nowrap"
                // zIndex="9999px"
                // className=' flex-col '
                
        
                
                 width="300px"
                height="620px"
                // backgroundColor="yellow"
                
                >
          <Image
          // src='/skteevent.JPG'
          borderRadius="15px"
          // src='/5r.jpg'
          src={img1}
          height="480px"
          width="600px"
          />
        
          <Flex
          position="relative"
          justifyContent="center"
          alignItems="center"
          direction="column"
          paddingLeft="5px"
          paddingRight="5px"
          paddingTop="25px"
          paddingBottom="25px">
        
        
          <Text 
          width="100%"
          textAlign="center"
          fontSize="20px"
          
          >
            Sign up to volunteer now!
          </Text>
           <motion.button
               
        
               whileHover={{ scale: 1.1 }}
               whileTap={{ scale: 0.9 }}
               onClick={() => {
                   navigate('/VolunteerSignUp')
               }}>
                   <Text
                   display="flex"
                   justifyContent="center"
                   alignItems="center"
                   width="200px"
                   height="40px"
                   backgroundColor="rgba(32, 78, 41, 0.8)"
                   borderRadius="5px"
                   textAlign="center"
                   fontWeight="bold"
                   color="white"
                   >
                   Sign Up
                   </Text>
          </motion.button>
          </Flex>
            </Grid>
           </motion.div> */}
      </Grid>
    </Flex>
  );
};
